import { render, staticRenderFns } from "./auto-docs-item.vue?vue&type=template&id=cb1cc3dc&scoped=true&lang=html&"
import script from "./auto-docs-item.vue?vue&type=script&lang=js&"
export * from "./auto-docs-item.vue?vue&type=script&lang=js&"
import style0 from "./auto-docs-item.vue?vue&type=style&index=0&id=cb1cc3dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1cc3dc",
  null
  
)

component.options.__file = "auto-docs-item.vue"
export default component.exports